import { gql } from '@apollo/client';

export const CREATE_AMBIENT_MONITOR = gql`
    mutation CreateAmbientMonitor($input: CreateAmbientMonitor!) {
        facility {
            process {
                createAmbientMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
